import ModelTypeConstants from 'constants/ModelTypeConstants';

import {DomainGraphType, ObjectType} from './CoreObjectConstants';

/**
 * DomainGraphTypes that have no corresponding ModelTypeConstants.
 *
 * These types are backend-only or have no frontend representation.
 * The DOMAIN_GRAPH_TYPE_TO_MODEL_TYPE_CONSTANT mapping is partial to exclude these types.
 *
 * @package
 */
export const DG_TYPES_WITHOUT_MODEL_TYPE_CONSTANT: ReadonlySet<ObjectType> = new Set([
  DomainGraphType.INTERNAL_PIPELINE,
]);

/**
 * Maps DomainGraphType to ModelTypeConstants.
 *
 * This file is auto-generated by the `addToCoreObjectCompatibilityMappings` codemod,
 * but it is safe to modify by hand when needed. Manual overrides will be preserved
 * during future code generation (e.g., DNA_SEQUENCE -> SEQUENCE instead of the
 * default DNA_SEQUENCE -> DNA_SEQUENCE).
 *
 * The codemod preserves manual changes by skipping new entries if either:
 * 1. The key (DomainGraphType) already exists, OR
 * 2. The value (ModelTypeConstants) is already used by another key
 *
 * Note: This mapping is partial. Types in DG_TYPES_WITHOUT_MODEL_TYPE_CONSTANT
 * have no ModelTypeConstants equivalent.
 *
 * @package
 */
export const DOMAIN_GRAPH_TYPE_TO_MODEL_TYPE_CONSTANT: Partial<Record<ObjectType, ModelTypeConstants>> = {
  [DomainGraphType.AA_PART_LINK_FIELD_DEFINITION]: ModelTypeConstants.AA_PART_LINK_FIELD_DEFINITION,
  [DomainGraphType.AA_SEQUENCE]: ModelTypeConstants.PROTEIN,
  [DomainGraphType.AA_SEQUENCE_LINK_FIELD_DEFINITION]: ModelTypeConstants.AA_SEQUENCE_LINK_FIELD_DEFINITION,
  [DomainGraphType.AA_SEQUENCE_SCHEMA]: ModelTypeConstants.AA_SEQUENCE_SCHEMA,
  [DomainGraphType.AGENT_SKILL]: ModelTypeConstants.AGENT_SKILL,
  [DomainGraphType.AGENT_SKILL_FILE]: ModelTypeConstants.AGENT_SKILL_FILE,
  [DomainGraphType.AI_MODEL]: ModelTypeConstants.AI_MODEL,
  [DomainGraphType.ANALYSIS]: ModelTypeConstants.ANALYSIS,
  [DomainGraphType.ANALYSIS_TEMPLATE]: ModelTypeConstants.ANALYSIS_TEMPLATE,
  [DomainGraphType.ANALYSIS_TEMPLATE_DATA_FRAME_VARIABLE]:
    ModelTypeConstants.ANALYSIS_TEMPLATE_DATA_FRAME_VARIABLE,
  [DomainGraphType.ANALYSIS_TEMPLATE_VARIABLE]: ModelTypeConstants.ANALYSIS_TEMPLATE_VARIABLE,
  [DomainGraphType.ANTIBODY_LINK_FIELD_DEFINITION]: ModelTypeConstants.ANTIBODY_LINK_FIELD_DEFINITION,
  [DomainGraphType.ANTIBODY_SCHEMA]: ModelTypeConstants.ANTIBODY_SCHEMA,
  [DomainGraphType.ANY_ENTITY_LINK_FIELD_DEFINITION]: ModelTypeConstants.ANY_ENTITY_LINK_FIELD_DEFINITION,
  [DomainGraphType.APP_DEFINITION]: ModelTypeConstants.APP_DEFINITION,
  [DomainGraphType.APP_DEFINITION_VERSION]: ModelTypeConstants.APP_DEFINITION_VERSION,
  [DomainGraphType.ASSAY_REQUEST_LINK_FIELD_DEFINITION]:
    ModelTypeConstants.ASSAY_REQUEST_LINK_FIELD_DEFINITION,
  [DomainGraphType.ASSAY_RESULT_LINK_FIELD_DEFINITION]: ModelTypeConstants.ASSAY_RESULT_LINK_FIELD_DEFINITION,
  [DomainGraphType.ASSAY_RUN_LINK_FIELD_DEFINITION]: ModelTypeConstants.ASSAY_RUN_LINK_FIELD_DEFINITION,
  [DomainGraphType.ASSEMBLY]: ModelTypeConstants.BULK_ASSEMBLY,
  [DomainGraphType.ASYNC_TASK]: ModelTypeConstants.ASYNC_TASK,
  [DomainGraphType.AUDIT_LOG]: ModelTypeConstants.AUDIT_LOG,
  [DomainGraphType.AV_SCAN_RECORD]: ModelTypeConstants.AV_SCAN_RECORD,
  [DomainGraphType.BASE_FIELD_DEFINITION]: ModelTypeConstants.BASE_FIELD_DEFINITION,
  [DomainGraphType.BENCHLING_OBJECT_SCHEMA_V2]: ModelTypeConstants.SCHEMA,
  [DomainGraphType.BLOB_LINK_FIELD_DEFINITION]: ModelTypeConstants.BLOB_LINK_FIELD_DEFINITION,
  [DomainGraphType.BLOCK_VISUALIZATION]: ModelTypeConstants.BLOCK_VISUALIZATION,
  [DomainGraphType.BOOLEAN_FIELD_DEFINITION]: ModelTypeConstants.BOOLEAN_FIELD_DEFINITION,
  [DomainGraphType.BOX]: ModelTypeConstants.BOX,
  [DomainGraphType.BOX_SCHEMA]: ModelTypeConstants.BOX_SCHEMA,
  [DomainGraphType.BUSINESS_RULE]: ModelTypeConstants.BUSINESS_RULE,
  [DomainGraphType.CHART]: ModelTypeConstants.CHART,
  [DomainGraphType.CHAT_SESSION]: ModelTypeConstants.CHAT_SESSION,
  [DomainGraphType.COLLABORATION]: ModelTypeConstants.COLLABORATION,
  [DomainGraphType.CONFIG_IMPORT_HISTORY_ENTRY]: ModelTypeConstants.CONFIG_IMPORT_HISTORY_ENTRY,
  [DomainGraphType.CONTAINER]: ModelTypeConstants.CONTAINER,
  [DomainGraphType.CONTAINER_SCHEMA]: ModelTypeConstants.CONTAINER_SCHEMA,
  [DomainGraphType.CUSTOM_ENTITY]: ModelTypeConstants.BASIC_FOLDER_ITEM,
  [DomainGraphType.CUSTOM_ENTITY_LINK_FIELD_DEFINITION]:
    ModelTypeConstants.CUSTOM_ENTITY_LINK_FIELD_DEFINITION,
  [DomainGraphType.CUSTOM_ENTITY_SCHEMA]: ModelTypeConstants.CUSTOM_ENTITY_SCHEMA,
  [DomainGraphType.DATA_FRAME]: ModelTypeConstants.DATA_FRAME,
  [DomainGraphType.DATASET]: ModelTypeConstants.DATASET,
  [DomainGraphType.DATE_FIELD_DEFINITION]: ModelTypeConstants.DATE_FIELD_DEFINITION,
  [DomainGraphType.DATE_TIME_FIELD_DEFINITION]: ModelTypeConstants.DATE_TIME_FIELD_DEFINITION,
  [DomainGraphType.DNA_OLIGO]: ModelTypeConstants.DNA_OLIGO,
  [DomainGraphType.DNA_OLIGO_LINK_FIELD_DEFINITION]: ModelTypeConstants.DNA_OLIGO_LINK_FIELD_DEFINITION,
  [DomainGraphType.DNA_OLIGO_SCHEMA]: ModelTypeConstants.DNA_OLIGO_SCHEMA,
  [DomainGraphType.DNA_PART_LINK_FIELD_DEFINITION]: ModelTypeConstants.DNA_PART_LINK_FIELD_DEFINITION,
  [DomainGraphType.DNA_SEQUENCE]: ModelTypeConstants.SEQUENCE,
  [DomainGraphType.DNA_SEQUENCE_LINK_FIELD_DEFINITION]: ModelTypeConstants.DNA_SEQUENCE_LINK_FIELD_DEFINITION,
  [DomainGraphType.DNA_SEQUENCE_SCHEMA]: ModelTypeConstants.DNA_SEQUENCE_SCHEMA,
  [DomainGraphType.DOCUMENT]: ModelTypeConstants.DOCUMENT,
  [DomainGraphType.DROPDOWN]: ModelTypeConstants.DROPDOWN,
  [DomainGraphType.DROPDOWN_FIELD_DEFINITION]: ModelTypeConstants.DROPDOWN_FIELD_DEFINITION,
  [DomainGraphType.ENTITY_SCHEMA]: ModelTypeConstants.TAG_SCHEMA,
  [DomainGraphType.ENTRY]: ModelTypeConstants.ENTRY,
  [DomainGraphType.ENTRY_LINK_FIELD_DEFINITION]: ModelTypeConstants.ENTRY_LINK_FIELD_DEFINITION,
  [DomainGraphType.ENTRY_SCHEMA]: ModelTypeConstants.ENTRY_SCHEMA,
  [DomainGraphType.ENTRY_SUBTEMPLATE]: ModelTypeConstants.SUBTEMPLATE,
  [DomainGraphType.ENTRY_TEMPLATE]: ModelTypeConstants.TEMPLATE,
  [DomainGraphType.ENZYME_LIST]: ModelTypeConstants.ENZYME_LIST,
  [DomainGraphType.EQUIPMENT_LINK_FIELD_DEFINITION]: ModelTypeConstants.EQUIPMENT_LINK_FIELD_DEFINITION,
  [DomainGraphType.EQUIPMENT_SCHEMA]: ModelTypeConstants.EQUIPMENT_SCHEMA,
  [DomainGraphType.EXAMPLE_TYPE]: ModelTypeConstants.EXAMPLE_TYPE,
  [DomainGraphType.FEATURE_LIBRARY]: ModelTypeConstants.FEATURE_LIBRARY,
  [DomainGraphType.FIELDSET]: ModelTypeConstants.SCHEMA_INTERFACE,
  [DomainGraphType.FIELDSET_LINK_FIELD_DEFINITION]: ModelTypeConstants.FIELDSET_LINK_FIELD_DEFINITION,
  [DomainGraphType.FILE]: ModelTypeConstants.FILE,
  [DomainGraphType.FLOAT_FIELD_DEFINITION]: ModelTypeConstants.FLOAT_FIELD_DEFINITION,
  [DomainGraphType.FOLDER]: ModelTypeConstants.FOLDER,
  [DomainGraphType.FORM_DEFINITION]: ModelTypeConstants.FORM_DEFINITION,
  [DomainGraphType.GERMLINE]: ModelTypeConstants.GERMLINE,
  [DomainGraphType.INTEGER_FIELD_DEFINITION]: ModelTypeConstants.INTEGER_FIELD_DEFINITION,
  [DomainGraphType.JELLYFISH]: ModelTypeConstants.JELLYFISH,
  [DomainGraphType.JELLYFISH_SCHEMA]: ModelTypeConstants.JELLYFISH_SCHEMA,
  [DomainGraphType.JSON_FIELD_DEFINITION]: ModelTypeConstants.JSON_FIELD_DEFINITION,
  [DomainGraphType.LABEL_TEMPLATE]: ModelTypeConstants.LABEL_TEMPLATE,
  [DomainGraphType.LADDER]: ModelTypeConstants.LADDER,
  [DomainGraphType.LEGACY_DATA_IMPORT_RUN]: ModelTypeConstants.LEGACY_DATA_IMPORT_RUN,
  [DomainGraphType.LIBRARY_PARAMETER_DEFINITION]: ModelTypeConstants.LIBRARY_PARAMETER_DEFINITION,
  [DomainGraphType.LOCATION]: ModelTypeConstants.LOCATION,
  [DomainGraphType.LOCATION_SCHEMA]: ModelTypeConstants.LOCATION_SCHEMA,
  [DomainGraphType.LONG_TEXT_FIELD_DEFINITION]: ModelTypeConstants.LONG_TEXT_FIELD_DEFINITION,
  [DomainGraphType.MATRIX_PLATE]: ModelTypeConstants.MATRIX_PLATE,
  [DomainGraphType.MATRIX_PLATE_SCHEMA]: ModelTypeConstants.MATRIX_PLATE_SCHEMA,
  [DomainGraphType.MCP_SERVER_CONFIG]: ModelTypeConstants.MCP_SERVER_CONFIG,
  [DomainGraphType.MCP_SERVER_DEFINITION]: ModelTypeConstants.MCP_SERVER_DEFINITION,
  [DomainGraphType.MCP_SERVER_USER_CONFIG]: ModelTypeConstants.MCP_SERVER_USER_CONFIG,
  [DomainGraphType.MIXTURE]: ModelTypeConstants.MIXTURE,
  [DomainGraphType.MIXTURE_LINK_FIELD_DEFINITION]: ModelTypeConstants.MIXTURE_LINK_FIELD_DEFINITION,
  [DomainGraphType.MIXTURE_SCHEMA]: ModelTypeConstants.MIXTURE_SCHEMA,
  [DomainGraphType.MOLECULE]: ModelTypeConstants.MOLECULE,
  [DomainGraphType.MOLECULE_LINK_FIELD_DEFINITION]: ModelTypeConstants.MOLECULE_LINK_FIELD_DEFINITION,
  [DomainGraphType.MOLECULE_SCHEMA]: ModelTypeConstants.MOLECULE_SCHEMA,
  [DomainGraphType.NUCLEOTIDE_ALIGNMENT]: ModelTypeConstants.NUCLEOTIDE_ALIGNMENT,
  [DomainGraphType.OLIGO_CONJUGATE]: ModelTypeConstants.OLIGO_CONJUGATE,
  [DomainGraphType.OLIGO_CONJUGATE_LINK_FIELD_DEFINITION]:
    ModelTypeConstants.OLIGO_CONJUGATE_LINK_FIELD_DEFINITION,
  [DomainGraphType.OLIGO_CONJUGATE_SCHEMA]: ModelTypeConstants.OLIGO_CONJUGATE_SCHEMA,
  [DomainGraphType.OLIGO_DUPLEX]: ModelTypeConstants.OLIGO_DUPLEX,
  [DomainGraphType.OLIGO_DUPLEX_LINK_FIELD_DEFINITION]: ModelTypeConstants.OLIGO_DUPLEX_LINK_FIELD_DEFINITION,
  [DomainGraphType.OLIGO_DUPLEX_SCHEMA]: ModelTypeConstants.OLIGO_DUPLEX_SCHEMA,
  [DomainGraphType.PIPELINE_STEP]: ModelTypeConstants.PIPELINE_STEP,
  [DomainGraphType.PLATE]: ModelTypeConstants.PLATE,
  [DomainGraphType.PLATE_SCHEMA]: ModelTypeConstants.PLATE_SCHEMA,
  [DomainGraphType.POLICY]: ModelTypeConstants.POLICY,
  [DomainGraphType.PREDICTION_BATCH]: ModelTypeConstants.PREDICTION_BATCH,
  [DomainGraphType.PRINTER]: ModelTypeConstants.PRINTER,
  [DomainGraphType.PROCEDURE]: ModelTypeConstants.PROCEDURE,
  [DomainGraphType.PROCEDURE_FLOWCHART]: ModelTypeConstants.PROCEDURE_FLOWCHART,
  [DomainGraphType.PROCEDURE_FLOWCHART_CONFIG_VERSION_PROXY]:
    ModelTypeConstants.PROCEDURE_FLOWCHART_CONFIG_VERSION_PROXY,
  [DomainGraphType.PROCEDURE_FLOWCHART_VERSION]: ModelTypeConstants.PROCEDURE_FLOWCHART_VERSION,
  [DomainGraphType.PROCEDURE_METHOD_DEFINITION_VERSION]:
    ModelTypeConstants.PROCEDURE_METHOD_DEFINITION_VERSION,
  [DomainGraphType.PROCEDURE_METHOD_EXECUTION_INSTANCE]:
    ModelTypeConstants.PROCEDURE_METHOD_EXECUTION_INSTANCE,
  [DomainGraphType.PROCEDURE_METHOD_EXECUTION_INSTANCE_ASSOCIATION]:
    ModelTypeConstants.PROCEDURE_METHOD_EXECUTION_INSTANCE_ASSOCIATION,
  [DomainGraphType.PROCEDURE_PARAMETER]: ModelTypeConstants.PROCEDURE_PARAMETER,
  [DomainGraphType.PROCEDURE_PARAMETER_CONFIRMATION_VALUE]:
    ModelTypeConstants.PROCEDURE_PARAMETER_CONFIRMATION_VALUE,
  [DomainGraphType.PROCEDURE_PARAMETER_MEASURED_VALUE]: ModelTypeConstants.PROCEDURE_PARAMETER_MEASURED_VALUE,
  [DomainGraphType.PROCEDURE_PARAMETER_PLANNED_VALUE]: ModelTypeConstants.PROCEDURE_PARAMETER_PLANNED_VALUE,
  [DomainGraphType.PROCEDURE_PARAMETER_VERSION]: ModelTypeConstants.PROCEDURE_PARAMETER_VERSION,
  [DomainGraphType.PROCEDURE_RUN]: ModelTypeConstants.PROCEDURE_RUN,
  [DomainGraphType.PROCEDURE_RUN_CONDITION]: ModelTypeConstants.PROCEDURE_RUN_CONDITION,
  [DomainGraphType.PROCEDURE_RUN_CONDITION_REPLICATE]: ModelTypeConstants.PROCEDURE_RUN_CONDITION_REPLICATE,
  [DomainGraphType.PROCEDURE_RUN_PLAN]: ModelTypeConstants.PROCEDURE_RUN_PLAN,
  [DomainGraphType.PROCEDURE_RUN_PLAN_CONDITION]: ModelTypeConstants.PROCEDURE_RUN_PLAN_CONDITION,
  [DomainGraphType.PROCEDURE_STEP_DEFINITION_VERSION]: ModelTypeConstants.PROCEDURE_STEP_DEFINITION_VERSION,
  [DomainGraphType.PROCEDURE_STEP_EXECUTION_INSTANCE]: ModelTypeConstants.PROCEDURE_STEP_EXECUTION_INSTANCE,
  [DomainGraphType.PROJECT]: ModelTypeConstants.PROJECT,
  [DomainGraphType.PROTEIN]: ModelTypeConstants.ANTIBODY,
  [DomainGraphType.PROTEIN_FORMAT]: ModelTypeConstants.ANTIBODY_FORMAT,
  [DomainGraphType.PUBLISHING_RECORD]: ModelTypeConstants.PUBLISHING_RECORD,
  [DomainGraphType.REACTION]: ModelTypeConstants.REACTION,
  [DomainGraphType.REGISTRY]: ModelTypeConstants.REGISTRY,
  [DomainGraphType.REQUEST_SCHEMA]: ModelTypeConstants.REQUEST_SCHEMA,
  [DomainGraphType.REQUEST_TASK_SCHEMA]: ModelTypeConstants.REQUEST_TASK_SCHEMA,
  [DomainGraphType.REQUEST_V2_DEFINITION]: ModelTypeConstants.REQUEST_V2_DEFINITION,
  [DomainGraphType.REQUEST_V2_SUBMISSION]: ModelTypeConstants.REQUEST_V2_SUBMISSION,
  [DomainGraphType.RESULT]: ModelTypeConstants.ASSAY_RESULT,
  [DomainGraphType.RESULT_SCHEMA]: ModelTypeConstants.RESULT_SCHEMA,
  [DomainGraphType.RNA_OLIGO]: ModelTypeConstants.RNA_OLIGO,
  [DomainGraphType.RNA_OLIGO_LINK_FIELD_DEFINITION]: ModelTypeConstants.RNA_OLIGO_LINK_FIELD_DEFINITION,
  [DomainGraphType.RNA_OLIGO_SCHEMA]: ModelTypeConstants.RNA_OLIGO_SCHEMA,
  [DomainGraphType.RNA_SEQUENCE]: ModelTypeConstants.RNA_SEQUENCE,
  [DomainGraphType.RNA_SEQUENCE_LINK_FIELD_DEFINITION]: ModelTypeConstants.RNA_SEQUENCE_LINK_FIELD_DEFINITION,
  [DomainGraphType.RNA_SEQUENCE_SCHEMA]: ModelTypeConstants.RNA_SEQUENCE_SCHEMA,
  [DomainGraphType.RUN]: ModelTypeConstants.RUN,
  [DomainGraphType.RUN_SCHEMA]: ModelTypeConstants.RUN_SCHEMA,
  [DomainGraphType.SALT]: ModelTypeConstants.SALT,
  [DomainGraphType.SAMPLE_DEFINITION]: ModelTypeConstants.SAMPLE_DEFINITION,
  [DomainGraphType.SAMPLE_TYPE]: ModelTypeConstants.SAMPLE_TYPE,
  [DomainGraphType.SCHEMA_LINK_FIELD_DEFINITION]: ModelTypeConstants.SCHEMA_LINK_FIELD_DEFINITION,
  [DomainGraphType.SCRATCH_FILE]: ModelTypeConstants.SCRATCH_FILE,
  [DomainGraphType.SCRATCH_PLATE]: ModelTypeConstants.SCRATCH_PLATE,
  [DomainGraphType.SOLVATE]: ModelTypeConstants.SOLVATE,
  [DomainGraphType.SQL_DASHBOARD]: ModelTypeConstants.SQL_DASHBOARD,
  [DomainGraphType.SQL_DASHBOARD_BLOCK]: ModelTypeConstants.SQL_DASHBOARD_BLOCK,
  [DomainGraphType.SQL_DASHBOARD_LINK]: ModelTypeConstants.SQL_DASHBOARD_LINK,
  [DomainGraphType.STAGE_ENTRY]: ModelTypeConstants.STAGE_ENTRY,
  [DomainGraphType.STAR]: ModelTypeConstants.STAR,
  [DomainGraphType.STATIC_SCHEMA_INTERFACE]: ModelTypeConstants.STATIC_SCHEMA_INTERFACE,
  [DomainGraphType.STATIC_VALIDATION_RULE_TEMPLATE]: ModelTypeConstants.STATIC_VALIDATION_RULE_TEMPLATE,
  [DomainGraphType.STORABLE_LINK_FIELD_DEFINITION]: ModelTypeConstants.STORABLE_LINK_FIELD_DEFINITION,
  [DomainGraphType.STUDY]: ModelTypeConstants.STUDY,
  [DomainGraphType.STUDY_ITEM_ASSOCIATION]: ModelTypeConstants.STUDY_ITEM_ASSOCIATION,
  [DomainGraphType.STUDY_SAMPLE_TEST_PLAN]: ModelTypeConstants.STUDY_SAMPLE_TEST_PLAN,
  [DomainGraphType.STUDY_SCHEMA]: ModelTypeConstants.STUDY_SCHEMA,
  [DomainGraphType.SYSTEM_CATEGORY_LINK_FIELD_DEFINITION]:
    ModelTypeConstants.SYSTEM_CATEGORY_LINK_FIELD_DEFINITION,
  [DomainGraphType.TEAM]: ModelTypeConstants.TEAM,
  [DomainGraphType.TEMPLATE_COLLECTION]: ModelTypeConstants.TEMPLATE_COLLECTION,
  [DomainGraphType.TENANT_CONFIG]: ModelTypeConstants.TENANT_CONFIG,
  [DomainGraphType.TENTACLE]: ModelTypeConstants.TENTACLE,
  [DomainGraphType.TEST_DEFINITION]: ModelTypeConstants.TEST_DEFINITION,
  [DomainGraphType.TEST_ORDER]: ModelTypeConstants.TEST_ORDER,
  [DomainGraphType.TEXT_FIELD_DEFINITION]: ModelTypeConstants.TEXT_FIELD_DEFINITION,
  [DomainGraphType.TRANSCRIPTION_LINK_FIELD_DEFINITION]:
    ModelTypeConstants.TRANSCRIPTION_LINK_FIELD_DEFINITION,
  [DomainGraphType.TRANSLATION_LINK_FIELD_DEFINITION]: ModelTypeConstants.TRANSLATION_LINK_FIELD_DEFINITION,
  [DomainGraphType.TREATMENT_GROUP]: ModelTypeConstants.TREATMENT_GROUP,
  [DomainGraphType.TRIAL_SAMPLE_TESTING_STUDY_DESIGN]: ModelTypeConstants.TRIAL_SAMPLE_TESTING_STUDY_DESIGN,
  [DomainGraphType.UNIT]: ModelTypeConstants.UNIT,
  [DomainGraphType.UNIT_TYPE]: ModelTypeConstants.UNIT_TYPE,
  [DomainGraphType.USER]: ModelTypeConstants.USER,
  [DomainGraphType.VALIDATION_RULE]: ModelTypeConstants.VALIDATION_RULE,
  [DomainGraphType.WAREHOUSE_CUSTOM_VIEW]: ModelTypeConstants.WAREHOUSE_CUSTOM_VIEW,
  [DomainGraphType.WELL_PLATE]: ModelTypeConstants.FIXED_PLATE,
  [DomainGraphType.WELL_PLATE_SCHEMA]: ModelTypeConstants.WELL_PLATE_SCHEMA,
  [DomainGraphType.WORKFLOW_END_NODE_DETAILS]: ModelTypeConstants.PROCESS_END_NODE_DETAILS,
  [DomainGraphType.WORKFLOW_FLOWCHART_CONFIG]: ModelTypeConstants.PROCESS_FLOWCHART_CONFIG,
  [DomainGraphType.WORKFLOW_FLOWCHART_CONFIG_VERSION]: ModelTypeConstants.PROCESS_FLOWCHART_CONFIG_VERSION,
  [DomainGraphType.WORKFLOW_FLOWCHART_EDGE_CONFIG]: ModelTypeConstants.PROCESS_FLOWCHART_EDGE_CONFIG,
  [DomainGraphType.WORKFLOW_FLOWCHART_NODE_CONFIG]: ModelTypeConstants.PROCESS_FLOWCHART_NODE_CONFIG,
  [DomainGraphType.WORKFLOW_OUTPUT]: ModelTypeConstants.PROCESS_OUTPUT,
  [DomainGraphType.WORKFLOW_OUTPUT_NODE_DETAILS]: ModelTypeConstants.PROCESS_OUTPUT_NODE_DETAILS,
  [DomainGraphType.WORKFLOW_OUTPUT_SCHEMA]: ModelTypeConstants.PROCESS_OUTPUT_SCHEMA,
  [DomainGraphType.WORKFLOW_ROOT_NODE_DETAILS]: ModelTypeConstants.PROCESS_ROOT_NODE_DETAILS,
  [DomainGraphType.WORKFLOW_ROUTER_FUNCTION]: ModelTypeConstants.PROCESS_ROUTER_FUNCTION,
  [DomainGraphType.WORKFLOW_ROUTER_NODE_DETAILS]: ModelTypeConstants.PROCESS_ROUTER_NODE_DETAILS,
  [DomainGraphType.WORKFLOW_TASK]: ModelTypeConstants.PROCESS_TASK,
  [DomainGraphType.WORKFLOW_TASK_DEFINITION]: ModelTypeConstants.PROCESS_TASK_DEFINITION,
  [DomainGraphType.WORKFLOW_TASK_DEFINITION_VERSION]: ModelTypeConstants.PROCESS_TASK_DEFINITION_VERSION,
  [DomainGraphType.WORKFLOW_TASK_GROUP]: ModelTypeConstants.PROCESS,
  [DomainGraphType.WORKFLOW_TASK_NODE_DETAILS]: ModelTypeConstants.PROCESS_TASK_NODE_DETAILS,
  [DomainGraphType.WORKFLOW_TASK_SCHEMA]: ModelTypeConstants.PROCESS_TASK_SCHEMA,
  [DomainGraphType.WORKLIST]: ModelTypeConstants.WORKLIST,
  [DomainGraphType.WORKSHEET]: ModelTypeConstants.WORKSHEET,
};

/** @package */
export const MODEL_TYPE_CONSTANT_TO_DOMAIN_GRAPH_TYPE: Partial<Record<ModelTypeConstants, ObjectType>> =
  Object.fromEntries(
    Object.entries(DOMAIN_GRAPH_TYPE_TO_MODEL_TYPE_CONSTANT)
      .filter((entry): entry is [string, ModelTypeConstants] => entry[1] != null)
      .map(([objectType, modelType]) => [modelType, objectType])
  ) as Record<ModelTypeConstants, ObjectType>;
